import { ShortcutTitle } from "@mirage/search/SearchResults/ShortcutTitle";
import { URLShortcutIcon } from "@mirage/shared/icons";

import { Text } from "@dropbox/dig-components/typography";
import { Box } from "@dropbox/dig-foundations";
import type { typeahead } from "@mirage/service-typeahead-search/service/types";
import { DashTruncateWithTooltip } from "@mirage/shared/util/DashTruncateWithTooltip";
import sharedStyles from "./shared.module.css";

const middot = " · ";

/**
 * This component is subject to Design Review (05/09/2025)
 * Leaving inline style objects in place for now - DG
 */
export const UrlShortcutResultRow = (props: {
  scoredResult: typeahead.ScoredURLShortcut;
  isSelected: boolean;
}) => {
  const { scoredResult, isSelected } = props;
  const { result } = scoredResult;
  const { title, url } = result.parameters;

  return (
    <Box
      display="flex"
      alignItems="center"
      width="100%"
      className={sharedStyles.rowContainer}
    >
      <Box marginRight="Micro Medium" className={sharedStyles.iconContainer}>
        <URLShortcutIcon result={result} />
      </Box>
      <Box display="flex" columnGap="Micro XSmall" alignItems="center">
        <Text size="large" style={{ flexShrink: 0 }}>
          <ShortcutTitle title={title} selected={isSelected} />
        </Text>
        <Text color="subtle">{middot}</Text>
        <Box
          style={{
            flexShrink: 1,
            textOverflow: "ellipsis",
            overflow: "hidden",
          }}
        >
          <Text size="medium" color="subtle">
            <DashTruncateWithTooltip lines={1} tooltipProps={{ title: url }}>
              {url}
            </DashTruncateWithTooltip>
          </Text>
        </Box>
      </Box>
    </Box>
  );
};
